import { useNavigate, useParams } from "react-router-dom";
import React, { useState } from "react";
import { Header } from "../Header-Assesment/Header";
import "./MainContentDisclaimer.css";
import { DisclaimerTemplete } from "./Disclaimer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { SidebarCol } from "../../chatMain/Sidebar/Sidebar";

export const MainContentDisclaimer = () => {
  return (
    <div className="disclaimer">
      <div className="sidebar-dis">
        <SidebarCol />
      </div>
      <div className="disclaimer-temp">
        <DisclaimerTemplete
          headerTitle="PEARLI Self-Assessment"
          headerSubtitle="Reflect on your well-being, one domain at a time"
          breadcrumbs={[
            { icon: faHouse, text: "Self Mindfulness" },
            { icon: faHouse, text: "PEARLI (General Life)" },
            { text: "Disclaimer", active: true },
          ]}
        />
      </div>
    </div>
  );
};
